module.exports = __webpack_public_path__ + "static/media/icon-user.953c14f4.svg";